import type { TemplateFunction, TemplateResult } from 'Components/types';
import { useSelector } from 'Core/store';
import uiConfig from 'Models/uiConfig/uiConfig';
import { keysSelector } from 'Modules/converter/index';

const {
  customMessage: { paramsKeys = [], visibleIf = () => false },
} = uiConfig;

interface Props {
  template: TemplateFunction<void>;
}

export default function CustomMessage({ template }: Props): TemplateResult {
  const visible = useSelector((state) => visibleIf(keysSelector(...paramsKeys)(state)));

  return visible ? template() : null;
}
